import React from 'react'
import {
  PlayerCardStyle,
  PlayerInfoCon,
  PlayerNameYearsCon,
  PlayerProfileCon,
  SecondaryRow,
} from '../styles'
import { formatNumberOrdinal } from '../../../../../Utils'
import { getUnleashedPlayerExperience } from '../../../../../Utils/Players/playersHelper'
import { UnleashedPlayer } from '../../SkillsChallenge/skillsHelper'
import { Img } from '../../../../../Components/Image/Img'
import { PLL_IMAGES } from '../../../../../Config/config'

type PlayerProps = {
  playerInfo: UnleashedPlayer | null
  side: 'left' | 'right'
  showAccolade?: boolean
}

export const UnleashedPlayerItem: React.FC<React.PropsWithChildren<PlayerProps>> = ({
  playerInfo,
  side,
  showAccolade = false,
}) => {
  const renderExperience = (player: UnleashedPlayer) => {
    let exp = getUnleashedPlayerExperience(player)
    return `${formatNumberOrdinal(exp)} year`
  }
  return (
    <>
      {playerInfo && (
        <PlayerCardStyle side={side}>
          <div className="unleashedCon">
            {side === 'right' && (
              <PlayerProfileCon side={side}>
                <Img src={playerInfo.profileUrl} alt={`${playerInfo.name} Profile`} />
              </PlayerProfileCon>
            )}
            <PlayerInfoCon side={side}>
              <div className="playerTitleContainer">
                {side === 'right' && (
                  <>
                    <h1>{playerInfo?.currentTeam?.jerseyNum ?? 0}</h1>
                    <PlayerNameYearsCon side={side}>
                      <h3>{`${playerInfo.name}`}</h3>
                      {playerInfo.yearsPro > 0 && <p>{renderExperience(playerInfo)}</p>}
                    </PlayerNameYearsCon>
                  </>
                )}
                {side === 'left' && (
                  <>
                    <PlayerNameYearsCon side={side}>
                      <h3>{`${playerInfo.name}`}</h3>
                      {playerInfo.yearsPro > 0 && <p>{renderExperience(playerInfo)}</p>}
                    </PlayerNameYearsCon>
                    <h1>{playerInfo?.currentTeam?.jerseyNum ?? 0}</h1>
                  </>
                )}
              </div>
              <SecondaryRow side={side}>
                <div className="positionText">
                  <strong>{playerInfo.position}</strong>
                </div>
                <Img
                  src={PLL_IMAGES.unleashedLogoAllStar}
                  alt={'Unleashed all star logo'}
                />
              </SecondaryRow>
            </PlayerInfoCon>
            {side === 'left' && (
              <PlayerProfileCon side={side}>
                <Img src={playerInfo.profileUrl} alt={`${playerInfo.name} Profile`} />
              </PlayerProfileCon>
            )}
          </div>
        </PlayerCardStyle>
      )}
    </>
  )
}
